import riskhub from "@/services/Riskhub/Riskhub";

export const dateFormatter = (data) => {
  return riskhub.formatDate(data.value);
}
export const dateTimeFormatter = (data) => {
  return riskhub.formatDateTime(data.value);
}

export default dateFormatter;
